module.exports = {"top3":["Home health patients without improved mobility","Employer-sponsored insurance spending per enrollee","Adults with inappropriate lower back imaging"],"bottom3":["Adults who have lost six or more teeth","Infant mortality","Hospital 30-day mortality"],"most_improved":["Nursing home residents with an antipsychotic medication","Home health patients without improved mobility","Uninsured adults"],"most_declined":["Preventable hospitalizations ages 18-64","Hospital 30-day mortality","Children who did not receive needed mental health care"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/AR.json
// module id = 242
// module chunks = 143196823979170 184088790168614